import { useEffect } from 'react';

declare global {
  interface Window {
    IAS?: {
      InAppStoryManager: new (config: any) => any;
      AppearanceManager: new () => any;
    };
    _inAppStoryInitialized?: boolean;
  }
}

const InAppStory = () => {
  useEffect(() => {
    if (typeof window === 'undefined' || window._inAppStoryInitialized) return;

    let manager: any;
    let storiesList: any;
    let checkInterval: NodeJS.Timeout;

    const initInAppStory = () => {
      if (!window.IAS) {
        console.error('IAS script not loaded');
        return;
      }

      try {
        manager = new window.IAS.InAppStoryManager({
          apiKey: process.env.NEXT_PUBLIC_STORIES_KEY,
        });

        const appearance = new window.IAS.AppearanceManager();
        appearance.setStoriesListOptions({
          card: { height: 130, gap: 16 },
          sidePadding: 0,
        });

        storiesList = new manager.StoriesList("#stories_widget", appearance, { feed: "default" });

        window._inAppStoryInitialized = true;
      } catch (error) {
        console.error('InAppStory initialization error:', error);
      }
    };

    if (window.IAS) {
      initInAppStory();
    } else {
      checkInterval = setInterval(() => {
        if (window.IAS) {
          clearInterval(checkInterval);
          initInAppStory();
        }
      }, 100);
    }

    return () => {
      // 1. Очистка интервала
      if (checkInterval) clearInterval(checkInterval);

      // 2. Удаление менеджера и списка историй
      if (storiesList && typeof storiesList.destroy === 'function') {
        storiesList.destroy();
      }

      // 3. Очистка глобального флага
      if (window._inAppStoryInitialized) {
        window._inAppStoryInitialized = false;
      }

      // 4. Дополнительная очистка менеджера, если доступна
      if (manager && typeof manager.destroy === 'function') {
        manager.destroy();
      }

      // 5. Очистка DOM элемента
      const widget = document.getElementById('stories_widget');
      if (widget) {
        widget.innerHTML = '';
      }
    };
  }, []);

  return (
    <div className="container">
      <div id="stories_widget" style={{ margin: '0 auto', maxWidth: '100%' }} />
    </div>
  )
};

export default InAppStory;